import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StandortEditComponent } from './standort_edit.component';

const routes: Routes = [
  {
    path: 'new',
    component: StandortEditComponent,
    data: { title: 'Neuer Standort' }
  },
  {
    path: ':id',
    component: StandortEditComponent,
    data: { title: 'Standort Bearbeiten' },
    // Allow both numeric IDs and UUIDs, but exclude error routes
    canActivate: [(route: any) => {
      const id = route.params.id;
      // Don't match if it's an error route
      if (id === 'error' || id === 'error-404' || id === '404' || id === 'fdsa') {
        return false;
      }
      // Allow numeric IDs (for backward compatibility) and UUIDs
      return !isNaN(Number(id)) && Number(id) > 0 || 
             /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
    }]
  },
  {
    path: '',
    redirectTo: '/standorte',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StandortEditRoutingModule { }







